import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { isBefore } from 'date-fns';
import { my_CkScadenzaOrgAmmHelper } from '../../warnings/amm-controllo-common-warnings';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';

@Injectable()
export class NormeSpaMonisticoWarningsService {
    constructor(private store: Store<Revisione53State>) {}

    my_CkScadenzaOrgAmm = createWarning(this.store, (myVerbale) => {
        return my_CkScadenzaOrgAmmHelper(myVerbale, CkNormeValuesEnum.normeSpaMonistico);
    });

    my_CkSpmTipoAmministrazione = createWarning(this.store, (myVerbale) => {
        const my_DataRevisioneDal = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal;
        const my_CkSpmTipoAmministrazione = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSpaMonistico.my_CkSpmTipoAmministrazione;
        const my_AllElemConsiglioAmministrazione = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllConsiglioAmministrazione.my_AllElemConsiglioAmministrazione;

        const date = new Date(my_DataRevisioneDal);
        const dateBefore = isBefore(date, new Date('01-01-2018'));

        if (!(my_CkSpmTipoAmministrazione != '1' || dateBefore || my_AllElemConsiglioAmministrazione.length >= 3)) {
            return "Attenzione : per le modifiche introdotte dalla legge di bilancio 2018, l'amministrazione della cooperativa non può essere affidata ad un CdA con meno di tre componenti";
        } else {
            return null;
        }
    });
}
